"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelLink = exports.useSetSidePanelKind = exports.SidePanel = exports.SidePanelProvider = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const react_split_1 = __importDefault(require("@uiw/react-split"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const hooks_1 = require("common/hooks");
const z = __importStar(require("zod"));
const url_1 = require("utils/url");
const schema = z.string();
const useStorage = (0, hooks_1.createUseStorage)("sidePanelWidth", schema);
const SidePanelContext = (0, react_1.createContext)({
    set: () => {
        throw new Error("SidePanelContext not found");
    },
    hasContext: false,
});
const SidePanelProvider = ({ children, }) => {
    const [sidePanelList, setSidePanelList] = (0, react_1.useState)([]);
    const [sidePanelWidth, setSidePanelWidth] = useStorage("30");
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: sidePanelKind, setValue: setSidePanelKind } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "sidePanelKind");
    const set = (0, react_1.useCallback)((id, component, title, kind, priority) => {
        setSidePanelList((prev) => [
            ...prev,
            { id, component, title, kind, priority },
        ]);
        return () => {
            setSidePanelList((prev) => prev.filter((item) => item.id !== id));
        };
    }, []);
    const context = (0, react_1.useMemo)(() => ({ set, hasContext: true }), [set]);
    const activeSidePanelId = (0, react_1.useMemo)(() => {
        if (sidePanelList.length === 0)
            return null;
        if (sidePanelKind) {
            const target = sidePanelList.find((item) => item.kind === sidePanelKind);
            if (target)
                return target.id;
        }
        return [...sidePanelList].sort((a, b) => {
            var _a, _b;
            return ((_a = a.priority) !== null && _a !== void 0 ? _a : 0) - ((_b = b.priority) !== null && _b !== void 0 ? _b : 0);
        })[0].id;
    }, [sidePanelList, sidePanelKind]);
    const activeSidePanel = (0, react_1.useMemo)(() => {
        if (activeSidePanelId === null)
            return null;
        return sidePanelList.find((item) => item.id === activeSidePanelId) || null;
    }, [activeSidePanelId, sidePanelList]);
    const handleDragEnd = (0, react_1.useCallback)((preSize, nextSize, paneNumber) => {
        if (paneNumber === 2) {
            setSidePanelWidth(nextSize.toString());
        }
    }, [setSidePanelWidth]);
    return (react_1.default.createElement(SidePanelContext.Provider, { value: context },
        react_1.default.createElement(react_split_1.default, { style: { display: "flex", height: "100%", gap: 6 }, onDragEnd: handleDragEnd, lineBar: true },
            !activeSidePanel && react_1.default.createElement("div", { style: { width: "100%" } }, children),
            activeSidePanel && (react_1.default.createElement("div", { style: { width: `${100 - Number.parseFloat(sidePanelWidth)}%` } }, children)),
            activeSidePanel && (react_1.default.createElement("div", { style: {
                    width: `${sidePanelWidth}%`,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    border: "solid 0.2px #D9D9D9",
                    boxShadow: "0px 0px 8px 0px #00000026",
                    overflowY: "scroll",
                    backgroundColor: "#fff",
                    height: "calc(100vh - 250px)",
                } },
                react_1.default.createElement("ul", { className: "nav nav-tabs", style: {
                        padding: "8px",
                        display: "flex",
                        gap: "4px",
                        borderBottom: "2px solid #D9D9D9",
                    } }, [...sidePanelList]
                    .sort((a, b) => {
                    var _a, _b;
                    return ((_a = a.priority) !== null && _a !== void 0 ? _a : 0) - ((_b = b.priority) !== null && _b !== void 0 ? _b : 0);
                })
                    .map((item) => {
                    const isActive = item.id === activeSidePanelId;
                    return (react_1.default.createElement("li", { key: item.id, className: "nav-item" },
                        react_1.default.createElement(Button_1.default, { type: "button", variant: "light", className: `nav-link px-2 py-1`, onClick: () => {
                                var _a;
                                setSidePanelKind((_a = item.kind) !== null && _a !== void 0 ? _a : "");
                            }, active: isActive, size: "sm", style: {
                                background: isActive ? "#e8e8f0" : undefined,
                                borderRadius: "6px",
                                border: "1px solid #D9D9D9",
                            } }, item.title)));
                })),
                react_1.default.createElement("div", { style: { width: "100%", overflow: "auto", padding: "15px 20px" }, className: "enableScrollbar" }, activeSidePanel.component))))));
};
exports.SidePanelProvider = SidePanelProvider;
const SidePanel = ({ children, title, kind, priority }) => {
    const { set, hasContext } = (0, react_1.useContext)(SidePanelContext);
    const [id] = (0, react_1.useState)(uuid_1.v4);
    (0, react_1.useEffect)(() => {
        if (!children)
            return;
        if (!hasContext)
            return;
        const unset = set(id, children, title, kind !== null && kind !== void 0 ? kind : null, priority !== null && priority !== void 0 ? priority : null);
        return () => {
            unset();
        };
    }, [children, title, set]);
    return null;
};
exports.SidePanel = SidePanel;
const useSetSidePanelKind = () => {
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { setValue } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "sidePanelKind");
    return (kind) => {
        setValue(kind);
    };
};
exports.useSetSidePanelKind = useSetSidePanelKind;
const SidePanelLink = ({ sidePanelKind, children }) => {
    const setSidePanelKind = (0, exports.useSetSidePanelKind)();
    return (react_1.default.createElement("a", { onClick: () => {
            setSidePanelKind(sidePanelKind);
        }, style: {
            color: "#2D73B9",
            fontWeight: 700,
        } }, children));
};
exports.SidePanelLink = SidePanelLink;
